import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { ExtensionRecommendations } from './extensionRecommendations.js';
import { IProductService } from 'vscode/vscode/vs/platform/product/common/productService.service';

let LanguageRecommendations = class LanguageRecommendations extends ExtensionRecommendations {
    get recommendations() { return this._recommendations; }
    constructor(productService) {
        super();
        this.productService = productService;
        this._recommendations = [];
    }
    async doActivate() {
        if (this.productService.languageExtensionTips) {
            this._recommendations = ( this.productService.languageExtensionTips.map(extensionId => ({
                extension: extensionId.toLowerCase(),
                reason: {
                    reasonId: 6 ,
                    reasonText: ''
                }
            })));
        }
    }
};
LanguageRecommendations = ( __decorate([
    ( __param(0, IProductService))
], LanguageRecommendations));

export { LanguageRecommendations };
